// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1077":"43dc678d12175f33","3125":"f47c8265b54b6370","7440":"0fe164c6a9440c5a"}[chunkId] + ".js";
};